var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTravelerIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33193 8.41667L5.94419 4.2475C5.79648 3.9896 5.7973 3.67255 5.94635 3.41542C6.0954 3.15828 6.37012 3 6.66733 3H7.59472C7.8164 3 8.02894 3.08833 8.18533 3.24544L13.3328 8.41667",
    stroke: "#959595",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.56729 12.1665L5.10062 16.7732C4.96234 17.0314 4.96984 17.3434 5.12037 17.5947C5.2709 17.846 5.54234 17.9998 5.8353 17.9998H6.80265C7.02532 17.9998 7.23872 17.9107 7.39526 17.7523L12.9175 12.1665",
    stroke: "#959595",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50001 12.1665H3.79573C3.07837 12.1665 2.44148 11.7075 2.21463 11.0269L0.876755 7.01336C0.792047 6.75924 0.834662 6.47989 0.991287 6.26258C1.14791 6.04527 1.39945 5.9165 1.66732 5.9165H2.8627C3.3143 5.91651 3.73077 6.16008 3.95217 6.55368L5.00001 8.4165H17.2917C18.3272 8.4165 19.1667 9.25597 19.1667 10.2915V10.2915C19.1667 11.327 18.3272 12.1665 17.2917 12.1665H12.9167",
    stroke: "#959595",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravelerIcon);
export default __webpack_public_path__ + "static/media/travelerIcon.b9628fb2c6b74f10c2e1c3c8590bf437.svg";
export { ForwardRef as ReactComponent };